import type { BankQuestion } from '@proref/types';
import { api, unwrap, type Envelope } from '../lib/api';

export interface ListBankQuestionsParams {
  // super_admin narrows to one sport; ignored for a federation_admin (pinned server-side).
  sportId?: string;
  ruleArticleId?: string;
  search?: string;
}

// The reusable rule-test question library, scoped to the admin server-side (own federation +
// platform for a federation_admin; the platform library for a super_admin). Includes each
// question's correct_answers (admin-only — never reached by a referee).
export async function listBankQuestions(params: ListBankQuestionsParams = {}): Promise<BankQuestion[]> {
  const query: Record<string, string> = {};
  if (params.sportId) query['sport_id'] = params.sportId;
  if (params.ruleArticleId) query['rule_article_id'] = params.ruleArticleId;
  if (params.search) query['search'] = params.search;
  const res = await api.get<Envelope<BankQuestion[]>>('/question-bank', {
    params: Object.keys(query).length > 0 ? query : undefined,
  });
  return unwrap(res.data);
}
